import PaywallMyAccountPersonalDetails from "./paywallMyAccountPersonalDetails"
import PaywallMyAccountLastPurchases from "./paywallMyAccountpLastPurchases"
import PaywallMyAccountTabs from "./paywallMyAccountTabs";
import { useEffect, useState } from "react";
import { useRedirect } from "../../../../global/paywall/useRedirect";
import { getPaywallSettingsFromLocalStorage, AuthLogOutLocal } from "../../../../global/paywall/authOperations";
import { getPersonalCustomerDetails } from "../../../../global/paywall/paywallApiUrls";
import * as axios from "axios";
import { PaywallAuthErrorCodes, SiteLinks } from "../../../../global/paywall/paywallInterfaces"
import { SettingLinks } from "../../premiumPaywallCheckout/components/premiumPaywallCheckout";
import { LinkTargetProperties } from "../../../../global/components/linkSettings/interfaces"
import { getNewlinkTargetProperties } from "../../ynet1280/ynetShops/data/ynetshopsData"

declare const window: Window & {
    PAYWALL_SITE_LINKS: SiteLinks;
}

const targetLink: LinkTargetProperties = { ...getNewlinkTargetProperties(), linkOpenType: "new" }
const contactUrl = typeof window !== "undefined" && window.PAYWALL_SITE_LINKS ? window.PAYWALL_SITE_LINKS.contact : '';
const authPageUrl = typeof window !== "undefined" && window.PAYWALL_SITE_LINKS ? window.PAYWALL_SITE_LINKS.auth : '';  
const privacyUrl = typeof window !== "undefined" && window.PAYWALL_SITE_LINKS ? window.PAYWALL_SITE_LINKS.privacy : '';

const settingLinks: SettingLinks = {
    authPage: { url: authPageUrl, target: targetLink },
    contact: { url: contactUrl, target: targetLink },
    privacy: { url: privacyUrl, target: targetLink },
};

const PaywallMyAccountComponenta = () => {

    const [shouldRedirect, setShouldRedirect] = useState(false);
    const [userData, setUserData] = useState<any>(null);

    useRedirect({ fallbackUrl: settingLinks.authPage.url , enabled: shouldRedirect });

    const checkUserAccess = async () => {
            const userDetails = getPaywallSettingsFromLocalStorage();
            if (!userDetails && !shouldRedirect) { 
                setShouldRedirect(true);
            } else {
                const { data } = await getUserData(getPersonalCustomerDetails()) as any;
                setUserData(data);
            }
    };

    useEffect(() => {
        if (!shouldRedirect) {  
            checkUserAccess();
        }
    }, []);

    const getUserData = async (url: string) => {
        try {
            const response = await axios.get(url); 
            return response.data;
        } catch (error) {
            const errorCode = error.response && error.response.data && error.response.data.error && error.response.data.error.errorCode;
            if( errorCode === PaywallAuthErrorCodes.NOT_AUTHORIZED) {
                AuthLogOutLocal();
                setShouldRedirect(true);
            }
        }
    };

    const tabs = [
        {
            label: "המשתמש שלי",
            content: <PaywallMyAccountPersonalDetails setUserData={setUserData}  userData={userData} />,
        },
        {
            label: "רכישות אחרונות",
            content: <PaywallMyAccountLastPurchases userData={userData} contactUsPage={settingLinks.contact} />,
        },
    ];

    return (
        <div className="PaywallMyAccountComponenta">
            { userData && <PaywallMyAccountTabs tabs={tabs} privacyPage={settingLinks.privacy} contactUsPage={settingLinks.contact} />}
        </div>
    );

};

export default PaywallMyAccountComponenta;

PaywallMyAccountComponenta.siteScriptName = "PaywallMyAccountComponenta"
